import AddCircleIcon from "@mui/icons-material/AddCircle";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  IconButton,
  IconButtonProps,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  debounce,
  styled,
} from "@mui/material";
import { Input, Select, Tag } from "antd";
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";
import { action } from "mobx";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { useEffect, useState } from "react";
import { BiMinus, BiSave } from "react-icons/bi";
import { IoArrowBackCircle } from "react-icons/io5";
import { RiAddFill } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import uuid from "react-uuid";
import { CategoryModel } from "services/listCategory_services";
import { RoutingModel } from "services/routing_services";
import {
  InfoPallet,
  RoutingDetail,
  WorkOrderDetailModel,
} from "services/workOrder_services";
import * as rootStore from "stores/root_store";
import { workOrderPresenter, workOrderStore } from "stores/root_store";
import { formatNumber } from "utils/formatHelper";
import CardItem from "./CardItem";
import HistoryConfirmStage from "./HistoryConfirmStage";
import MoldInfo from "./MoldInfo";
import ComponentInfo from "./componentInfo";
import dataTitle from "./dataTitle";
import PalletDetail from "./palletDetail";
import { getUserSession } from "utils/localStorageHelper";
import { User } from "services/user_services";

const { Option } = Select;
const { TextArea } = Input;

// import request from 'umi-request';

interface DataShareModel {
  title: string;
  value: string;
  status?: string;
  input?: boolean;
  visible: boolean;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Style = {
  MuiTableCellRoot: {
    fontSize: "13px",
    fontWeight: 700,
    padding: "5px 10px",
    lineHeight: "20px",
    color: "white",
    whiteSpace: "nowrap",
  },
  borderInherit: {
    borderCollapse: "inherit",
  },
  MuiButtonBaseRoot: {
    color: "white !important",
  },
  MuiTableCellRootTd: {
    fontSize: "13px",
    padding: "5px 15px",
    lineHeight: "20px",
    borderBottom: "unset",
    minWidth: "180px",
  },
  minWidth: {
    minWidth: "unset!important",
  },
  sticky1: {
    position: "sticky",
    left: 0,
    background: "white",
    zIndex: 5,
  },
  sticky2: {
    position: "sticky",
    left: 47.2,
    background: "white",
    zIndex: 5,
  },
  sticky3: {
    position: "sticky",
    left: 296.5,
    background: "white",
    zIndex: 5,
    color: "#0284c7",
  },

  ".MuiOutlinedInput-root": {
    padding: 0,
  },
  "Mui-disabled": {
    background: "white",
  },
  ".MuiOutlinedInput-input": {
    fontSize: "13px",
    background: "white!important",
  },
  ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
};

export const waitTimePromise = async (time: number = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const waitTime = async (time: number = 100) => {
  await waitTimePromise(time);
};

export function createWODetail() {
  return observer(() => {
    // ============ Navigation =================/
    const navigate = useNavigate();
    // Lấy parameter trên url
    const { workOrderId = "" } = useParams();
    const [expanded, setExpanded] = useState(true);

    // ==========================================//
    const [dataRouting, setDataRouting] = useState<
      WorkOrderDetailModel | undefined
    >(workOrderStore.getWODetailsResponse.data);
    const [renderRouting, setRenderRouting] = useState<RoutingDetail[]>([]);
    const [isEdit, setIsEdit] = useState(false);

    // ============ Loading toàn trang =========//
    const [loading, setLoading] = useState(false);
    //==========================================//
    const [value, setValue] = useState("1");

    // ===============================================//
    const [listPalletDetail, setListPalletDetail] = useState<
      InfoPallet | undefined
    >();

    const [listRouting, setListRouting] = useState<RoutingModel[]>([]);
    const [listMold, setListMold] = useState<CategoryModel[]>([]);
    const [dropDownMold, setDropDownMold] = useState<string[]>([]);
    const [listValueMold, setListValueMold] = useState<string[] | null>([]);
    const [editLSX, setEditLSX] = useState(false);

    // ============ Data Thông tin chung ============//
    const dataShared: Array<DataShareModel> = [
      {
        title: "Lệnh sản xuất",
        value: workOrderStore.getWODetailsResponse.data?.workOrderCode,
        visible: true,
      },
      {
        title: "Mã TP/BTP",
        value: workOrderStore.getWODetailsResponse.data?.productCode,
        visible: true,
      },
      {
        title: "Khách hàng",
        value: workOrderStore.getWODetailsResponse.data?.customerName,
        visible: true,
      },
      {
        title: "Loại LSX",
        value: workOrderStore.getWODetailsResponse.data?.woType,
        visible: true,
      },
      {
        title: "Tên TP/BTP",
        value: workOrderStore.getWODetailsResponse.data?.productName,
        visible: true,
      },
      {
        title: "Phiếu tiếp nhận thông tin",
        value: workOrderStore.getWODetailsResponse.data?.inforForm,
        visible: true,
      },
      {
        title: "Mã LSX tổng hợp",
        value: workOrderStore.getWODetailsResponse.data?.parentWorkOrderCode,
        visible: true,
      },
      //
      {
        title: "Kích thước sản phẩm",
        value: workOrderStore.getWODetailsResponse.data?.productSize,
        visible: true,
      },
      {
        title: "Số PO/Hợp đồng/Báo giá",
        value: workOrderStore.getWODetailsResponse.data?.poCode,
        visible: true,
      },

      {
        title: "Lệnh thiết kế",
        value: workOrderStore.getWODetailsResponse.data?.matchCard
          ? workOrderStore.getWODetailsResponse.data?.matchCard
          : "",
        input: true,
        visible: true,
      },
      {
        title: "Kích thước khổ trải SP (mm)",
        value: workOrderStore.getWODetailsResponse.data?.productSpreadSize,
        visible: true,
      },

      {
        title: "Công ty gia công in",
        value: workOrderStore.getWODetailsResponse.data?.printCompany,
        visible: true,
      },

      {
        title: "Tên hạng mục in ",
        value: workOrderStore.getWODetailsResponse.data?.printItem,
        visible: true,
      },

      {
        title: "Tình trạng SP",
        value: workOrderStore.getWODetailsResponse.data?.productStatus,
        visible: true,
      },

      {
        title: "NCC Kẽm",
        value: workOrderStore.getWODetailsResponse.data?.zincSupplier,
        visible: true,
      },

      {
        title: "Kiểu in",
        value: workOrderStore.getWODetailsResponse.data?.printStyle,
        visible: true,
      },
      //
      {
        title: "SPTK",
        value: workOrderStore.getWODetailsResponse.data?.designVote,
        visible: true,
      },
      {
        title: "Đơn vị gia công TP",
        value: workOrderStore.getWODetailsResponse.data?.processingUnit,
        visible: true,
      },

      {
        title: "Ngày ban hành LSX",
        value: workOrderStore.getWODetailsResponse.data?.documentDate,
        visible: true,
      },

      {
        title: "BOM",
        value: workOrderStore.getWODetailsResponse.data?.bomVersion,
        visible: true,
      },

      {
        title: "Ngày bắt đầu SX dự kiến",
        value: workOrderStore.getWODetailsResponse.data?.estimateFromDate,
        visible: true,
      },

      {
        title: "Số lượng phát lệnh",
        value: workOrderStore.getWODetailsResponse.data?.quantity,
        visible: true,
      },

      {
        title: "Tên Routing",
        value: workOrderStore.getWODetailsResponse.data?.routingName,
        visible: true,
      },
      {
        title: "Ngày kết thúc SX dự kiến",
        value: workOrderStore.getWODetailsResponse.data?.estimateToDate,
        visible: true,
      },

      {
        title: "Số lượng giao mẫu",
        value: `${workOrderStore.getWODetailsResponse.data?.sampleQty
          ? `${formatNumber(
            workOrderStore.getWODetailsResponse.data?.sampleQty,
            0
          )} ${workOrderStore.getWODetailsResponse.data?.unitSO
            ? workOrderStore.getWODetailsResponse.data?.unitSO
            : ""
          }`
          : ""
          } `,
        visible: true,
      },

      {
        title: "Mã bản vẽ",
        value: workOrderStore.getWODetailsResponse.data?.drawCode,
        visible: true,
      },
      {
        title: "Ngày bắt đầu SX thực tế",
        value: workOrderStore.getWODetailsResponse.data?.actualStartDate,
        visible: true,
      },

      {
        title: "Đơn vị tính",
        value: workOrderStore.getWODetailsResponse.data?.unit,
        visible: true,
      },

      {
        title: "Mã bản vẽ khuôn",
        value: workOrderStore.getWODetailsResponse.data?.moldDrawCode,
        visible: true,
      },
      {
        title: "Ngày kết thúc SX thực tế",
        value: workOrderStore.getWODetailsResponse.data?.actualEndDate,
        visible: true,
      },

      {
        title: "Ngày yêu cầu có hàng in",
        value: workOrderStore.getWODetailsResponse.data?.printReqDate,
        visible: true,
      },
      //
      {
        title: "Loại FSC",
        value: workOrderStore.getWODetailsResponse.data?.fcs,
        visible: true,
      },
      {
        title: "Trạng thái Netsuite",
        value: workOrderStore.getWODetailsResponse.data?.printStatus,
        visible: true,
      },
      {
        title: "Ngày yêu cầu nhập kho",
        value: moment(
          workOrderStore.getWODetailsResponse.data?.deliveryDate
        ).format("DD/MM/YYYY"),
        visible: true,
      },
      //
      {
        title: "Mô tả sản phẩm ",
        value: workOrderStore.getWODetailsResponse.data?.productNote,
        visible: true,
      },
      {
        title: "Trạng thái MES",
        value: workOrderStore.getWODetailsResponse.data
          ? workOrderStore.getWODetailsResponse.data?.productionStatus
          : "",
        status: workOrderStore.getWODetailsResponse.data
          ? workOrderStore.getWODetailsResponse.data?.productionStatusCode
          : "",
        input: true,
        visible: true,
      },
      {
        title: "Quy cách đóng gói",
        value: workOrderStore.getWODetailsResponse.data?.specification,
        visible: true,
      },

      // Khoảng trống
      {
        title: "",
        value: "",
        visible: true,
      },
      // Khoảng trống
      {
        title: "",
        value: "",
        visible: true,
      },
      // {
      //   title: "Ghi chú mẫu kèm theo",
      //   value: "",
      //   visible: true,
      // },

      {
        title: "Ghi chú sản xuất",
        value: workOrderStore.getWODetailsResponse.data?.attachedNote,
        visible: true,
      },

      // {
      //   title: "Số lượng SP đặt hàng",
      //   value: `${
      //     workOrderStore.getWODetailsResponse.data?.orderQty
      //       ? `${formatNumber(
      //           workOrderStore.getWODetailsResponse.data?.orderQty,
      //           0
      //         )} ${
      //           workOrderStore.getWODetailsResponse.data?.unitSO
      //             ? workOrderStore.getWODetailsResponse.data?.unitSO
      //             : ""
      //         }`
      //       : ""
      //   } `,
      //   visible: true,
      // },
    ];

    // ============================================//

    const getDropDownRouting = async (keyWord = "") => {
      await rootStore.routingPresenter.getListRouting(
        rootStore.routingStore,
        keyWord
      );
      setListRouting(rootStore.routingStore.routing.data);
    };

    // get list data mold(khuôn)
    const getDropdownMold = async (product = "", isMold = true) => {
      // await rootStore.productRoutingPresenter.getListMolds(
      //   rootStore.productRoutingStore,
      //   product,
      //   isMold
      // );
      if (rootStore.commonDateStore.listMoldAll.length === 0) {
        await rootStore.commonDatePresenter.getAllMolds(rootStore.commonDateStore)
      }
      setListMold(rootStore.commonDateStore.listMoldAll);
    };

    const debounceHandler = debounce(getDropdownMold, 300);

    // ========================= HANDLE CHANG VALUE THÔNG TIN CÔNG ĐOẠN SẢN XUẤT ===========================
    // handle value Number
    const handleChangeValue = (
      e: React.SyntheticEvent<Element, Event>,
      index: number,
      field: string,
      value?: number | string
    ) => {
      const data = [...renderRouting];
      Object.assign(data[index], {
        [field]: value,
      });
      setRenderRouting(data);
    };

    // handle value text String
    const handleChangeString = (
      e: React.ChangeEvent<HTMLTextAreaElement>,
      field: string,
      index: number
    ) => {
      const temp = [...renderRouting];
      temp.splice(index, 1, { ...temp[index], [field]: e.target.value });
      setRenderRouting(temp);
    };

    // handle value AutoComplete
    const handleChangeAuto = (
      value: string,
      option: RoutingModel | RoutingModel[],
      index: number,
      id: string
    ) => {
      const tempt = [...renderRouting];
      if (option && !Array.isArray(option)) {
        const idx = renderRouting.findIndex((item) => item.woRoutingId === id);
        // Object.assign(renderRouting[idx], {
        //   stepName: option?.stepName,
        //   stepCode: option?.stepCode,
        // });
        tempt[idx].step = option?.stepCode;
        tempt[idx].stepName = option?.stepName;
      }
      setRenderRouting(tempt);
    };

    // handle value AutoComplete multiple
    const handleChangeAutoMulti = (
      _: CategoryModel[],
      option: CategoryModel | CategoryModel[],
      index: number
    ) => {
      console.log("otp", option);
      if (option && Array.isArray(option)) {
        Object.assign(renderRouting[index], {
          molds: option.map((i, idx) => {
            return i.key ? i.key : renderRouting[index].molds.at(idx);
          }),
        });
        console.log(renderRouting[index]);
      }
      setRenderRouting(renderRouting);
    };

    const handleAddRow = () => {
      const temp = {
        step: "",
        stepCode: "",
        stepName: "",
        orderIndex: 0,
        productionGuide: "",
        productPerPage: 0,
        productPerStep: 0,
        totalQuantity: 0,
        stepSplit: "",
        componentUsed: "",
        estimateComplete: 0,
        isAllowDeleteMold: true,
        moldCode: "",
        molds: [],
        ratedTime: 0,
        setupTime: 0,
        soLuongGhiNhanDat: 0,
        soLuongGhiNhanKhongDat: 0,
        // Số lượng công nhân kế hoạch
        quantityOfWorker: 0,
        // Số lượng máy móc kế hoạch
        quantityEquipPerStep: 0,
        woRoutingId: uuid(),
      };
      setRenderRouting([...(renderRouting ?? []), temp]);
    };

    const handleDelete = action((id: string) => {
      const temp = renderRouting;
      const newData = temp?.filter((obj) => obj.woRoutingId !== id);
      setRenderRouting(newData);
    });

    const handleSaveRoutingDetail = async () => {
      setLoading(true);
      const woRoutingListFiltered: any[] | undefined = renderRouting?.map(
        (item) => {
          return {
            workOrderId: workOrderId,
            woRoutingId: item.woRoutingId,
            orderIndex: item.orderIndex,
            stepCode: item.step,
            productionGuide: item.productionGuide,
            componentUsed: item.componentUsed,
            productPerPage: item.productPerPage,
            ratedTime: item.ratedTime,
            setupTime: item.setupTime,
            molds: item.molds,
            isAllowDeleteMold: true,
            quantityOfWorker: item.quantityOfWorker,
            quantityEquipPerStep: item.quantityEquipPerStep,
            routingName: dataRouting?.description,
            tgCanhMay: item.tgCanhMay,
            slnhanCongCanhMay: item.slNhanCongCanhMay
          };
        }
      );

      const dataSave = {
        workOrderId: workOrderId,
        woRoutingList: woRoutingListFiltered,
      };

      await workOrderPresenter.updateWORouting(workOrderStore, dataSave);
      if (workOrderStore.updateWOMoldResponse.isSuccess) {
        toast.success(workOrderStore.updateWOMoldResponse.message);
        setTimeout(async () => {
          // window.location.reload();
          setLoading(false);
          await workOrderPresenter.getWorkOrderDetails(
            workOrderStore,
            workOrderId
          );
          if (workOrderStore.getWODetailsResponse.isSuccess) {
            setListPalletDetail(
              workOrderStore.getWODetailsResponse.data?.infoPallet
            );
            setDataRouting(workOrderStore.getWODetailsResponse.data);
            setRenderRouting(
              workOrderStore.getWODetailsResponse.data?.routingDetails || []
            );
          }
          setLoading(false);
        }, 2000);
        // setLoading(false);
      } else {
        toast.error(workOrderStore.updateWOMoldResponse.message);
        setLoading(false);
      }
    };

    const handleEdit = () => {
      setIsEdit(true);
    };

    const pagePermissions = () => {
      // Kiểm tra đường dẫn
      // check phân quyền bằng đường dẫn
      // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
      const path = window.location.pathname;
      const user = getUserSession() as User;
      const filteredData = user.webPermission.pageModel.filter((item) => {
        const itemNames = item.pageUrl.split(" ");
        return itemNames.some((name) => path.includes(name));
      });
      if (filteredData.length) {
        const permission = user.webPermission.pagePermissionModel.filter(
          (item) => item.pageId === filteredData[0].pageId
        );
        if (permission.length) {
          if (
            permission.findIndex((item) => item.functionId === "EDITLSX") > -1
          ) {
            setEditLSX(true);
          }
        }
      }
    };

    useEffect(() => {
      const data = listMold.map((i) => {
        return i.key ?? "";
      });
      const data2 = listMold.map((i) => {
        return i.value;
      });
      setDropDownMold(data);
      setListValueMold(data2);
    }, [listMold]);

    useEffect(() => {
      // phân quyền
      pagePermissions();

      // Loading khi call api
      setLoading(true);
      const getWorkOrderDetails = async () => {
        await workOrderPresenter.getWorkOrderDetails(
          workOrderStore,
          workOrderId
        );
        if (workOrderStore.getWODetailsResponse.isSuccess) {
          setListPalletDetail(
            workOrderStore.getWODetailsResponse.data?.infoPallet
          );
          setDataRouting(workOrderStore.getWODetailsResponse.data);
          setRenderRouting(
            workOrderStore.getWODetailsResponse.data?.routingDetails || []
          );
        }
        setLoading(false);
      };
      getWorkOrderDetails();
      getDropDownRouting();
      getDropdownMold();
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue);
    };

    const handleExpandClick = () => {
      setExpanded(!expanded);
    };

    // ======================================================//
    return (
      <div className="relative w-full p-5 py-3">
        {loading && <LoadingScreen />}
        {/* nút back */}
        <div className="flex items-center mb-3">
          <h3 className="text-default font-bold text-gray-800 uppercase">
            Thông tin lệnh sản xuất
          </h3>

          <span
            onClick={() => navigate("./../../")}
            className="flex items-center text-xs text-primary cursor-pointer font-medium w-fit"
          >
            <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
            Quay lại
          </span>
        </div>
        {/* ================================================================= */}
        <div className="w-full bg-white py-3 rounded mb-2 border border-neutral-300">
          {/* <Box sx={{ width: '100%', typography: 'body1' }}> */}
          <TabContext value={value && value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab
                  sx={{ fontSize: 12, fontWeight: "700", color: "#000" }}
                  label="Thông tin chung"
                  value="1"
                />
                <Tab
                  sx={{ fontSize: 12, fontWeight: "700", color: "#000" }}
                  label="Thông tin thẻ treo"
                  value="2"
                />
                <Tab
                  sx={{ fontSize: 12, fontWeight: "700", color: "#000" }}
                  label="Lịch sử xác nhận hoàn thành công đoạn"
                  value="3"
                />
              </TabList>
            </Box>
            <TabPanel value="1">
              <div className={`overflow-x-auto`}>
                {/* ======================== Thông tin dùng chung ============================== */}
                <CardItem
                  className="text-default"
                  title="Thông tin dùng chung"
                  idMatchCard={
                    workOrderStore.getWODetailsResponse.data?.matchCardId
                  }
                  data={dataShared}
                  shared
                />
                {/* ======================== Thông tin componet ================================ */}
                {workOrderStore.getWODetailsResponse.data?.components && (
                  <ComponentInfo
                    className="text-default mt-3"
                    title="Thông tin component"
                    data={workOrderStore.getWODetailsResponse.data.components}
                    components
                  />
                )}
                {/* ======================== Thông tin khuôn =================================== */}
                {workOrderStore.getWODetailsResponse.data?.woMolds && (
                  <MoldInfo
                    className="text-default mt-3"
                    title="Thông tin khuôn"
                    data={workOrderStore.getWODetailsResponse.data.woMolds}
                    woMolds
                  />
                )}
                {/* ======================== Thông tin công đoạn sản xuất =================================== */}
                <Card className="mt-3">
                  <CardActions disableSpacing className="bg-primary !p-1">
                    <Typography className="!text-default text-white !ml-3">
                      Thông tin công đoạn sản xuất
                    </Typography>
                    <ExpandMore
                      expand={expanded}
                      onClick={handleExpandClick}
                      aria-expanded={expanded}
                      aria-label="show more"
                    >
                      {expanded ? (
                        <BiMinus className="!text-white !text-base" />
                      ) : (
                        <RiAddFill className="!text-white !text-base" />
                      )}
                    </ExpandMore>
                  </CardActions>
                  <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent className="border rounded-b border-primary !pb-3">
                      <div className={`overflow-x-auto my-1`}>
                        {/* =========== Table Work Order ===============*/}
                        <div className="sticky left-0 w-full flex justify-between mb-4">
                          <button
                            disabled={!isEdit}
                            onClick={handleAddRow}
                            className="flex items-center rounded-sm bg-primary text-white text-default py-1 px-2.5 mr-3"
                          >
                            <AddCircleIcon className="!text-base mr-0.5" />
                            Thêm
                          </button>
                          {/* kiểm tra phân quyền  */}
                          {editLSX ? (
                            isEdit ? (
                              <button
                                disabled={loading}
                                onClick={handleSaveRoutingDetail}
                                className="flex items-center rounded-sm bg-primary text-white text-default py-1 px-2.5 mr-3 disabled:bg-gray-600"
                              >
                                <BiSave className="text-base mr-0.5" />
                                Lưu
                              </button>
                            ) : (
                              <button
                                onClick={handleEdit}
                                className="flex items-center rounded-sm bg-primary text-white text-default py-1 px-2.5 mr-3"
                              >
                                <EditIcon className="!text-base mr-0.5" />
                                Chỉnh sửa
                              </button>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                        <div className={`overflow-x-auto`}>
                          <TableContainer
                            component={Paper}
                            className="w-full table-auto overflow-y-hidden space-collapse mb-1 text-default"
                          >
                            <Table
                              className="w-full"
                              aria-label="simple table"
                              sx={Style.borderInherit}
                            >
                              <TableHead className="font-medium text-gray-700  text-default bg-gray-100">
                                <TableRow>
                                  {isEdit ? (
                                    <TableCell
                                      sx={[Style.MuiTableCellRoot]}
                                      className=" py-2 px-2 border text-center whitespace-nowrap bg-primary/80"
                                    >
                                      {/* Xóa*/}
                                      Xóa
                                    </TableCell>
                                  ) : (
                                    ""
                                  )}
                                  <TableCell
                                    sx={[Style.MuiTableCellRoot]}
                                    className=" py-2 px-2 border text-center whitespace-nowrap bg-primary/80"
                                  >
                                    {/* STT */}
                                    Thứ tự công đoạn
                                  </TableCell>
                                  {dataTitle.routingDetailColumns.map(
                                    (item, index) => {
                                      if (item.visible) {
                                        return (
                                          <TableCell
                                            key={index}
                                            sx={[Style.MuiTableCellRoot]}
                                            scope="col"
                                            align={`${item.align === "text-center"
                                              ? "center"
                                              : "inherit"
                                              }`}
                                            className={`${item.visible ? "" : "hidden"
                                              }
                                  ${item.width}
                                  py-2 px-2 border  bg-primary/80 ${item.align
                                              }`}
                                          >
                                            {item.columnName}
                                          </TableCell>
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {renderRouting?.length ? (
                                  renderRouting?.map((item, index) => {
                                    return (
                                      <TableRow
                                        className={`${index % 2 !== 0
                                          ? "bg-gray-50"
                                          : "bg-white"
                                          } hover:bg-gray-100`}
                                        key={item.woRoutingId}
                                      >
                                        {isEdit ? (
                                          // Nút xóa
                                          <TableCell
                                            sx={[
                                              Style.MuiTableCellRootTd,
                                              Style.minWidth,
                                            ]}
                                            className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                          >
                                            <Button
                                              disabled={
                                                item.soLuongGhiNhanDat +
                                                item.soLuongGhiNhanKhongDat !==
                                                0
                                              }
                                              className="!bg-blue-600"
                                              onClick={() => {
                                                handleDelete(item.woRoutingId);
                                              }}
                                            >
                                              <ClearIcon className="!text-sm !text-white" />
                                            </Button>
                                          </TableCell>
                                        ) : (
                                          ""
                                        )}
                                        {/* Thứ tự công đoạn */}
                                        <TableCell
                                          sx={[
                                            Style.MuiTableCellRootTd,
                                            Style.minWidth,
                                          ]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField
                                              disabled={
                                                item.soLuongGhiNhanDat +
                                                item.soLuongGhiNhanKhongDat !==
                                                0
                                              }
                                              defaultValue={item.orderIndex}
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "orderIndex",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className={
                                                "text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                              }
                                            />
                                          ) : (
                                            item.orderIndex
                                          )}
                                        </TableCell>
                                        {/* Mã Công đoạn */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full text-left text-gray-700 text-13px  px-1 py-1 text-default focus-visible:outline-none bg-white focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {item.step}
                                        </TableCell>
                                        {/* Tên công đoạn */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full text-left text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0 "
                                        >
                                          {isEdit ? (
                                            <Select
                                              showSearch
                                              allowClear
                                              className="!w-[200px]"
                                              size="small"
                                              value={item.stepName}
                                              fieldNames={{
                                                label: "stepName",
                                                value: "stepCode",
                                              }}
                                              options={listRouting}
                                              onChange={(value, option) => {
                                                handleChangeAuto(
                                                  value,
                                                  option,
                                                  index,
                                                  item.woRoutingId
                                                );
                                              }}
                                              optionFilterProp="children"
                                              filterOption={(input, option) =>
                                                (option?.stepName ?? "")
                                                  .toLowerCase()
                                                  .includes(input.toLowerCase())
                                              }
                                            />
                                          ) : (
                                            item.stepName
                                          )}
                                        </TableCell>
                                        {/* Số lượng đã ghi nhận */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full text-left text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {`${item.soLuongGhiNhanDat}Đ | ${item.soLuongGhiNhanKhongDat}KĐ`}
                                        </TableCell>
                                        {/* Hướng dẫn sản xuất */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full text-left text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextArea
                                              value={item.productionGuide}
                                              size="small"
                                              className="!w-[400px] !rounded-none"
                                              onChange={(e) => {
                                                handleChangeString(
                                                  e,
                                                  "productionGuide",
                                                  index
                                                );
                                              }}
                                              autoSize
                                            />
                                          ) : (
                                            item.productionGuide
                                          )}
                                        </TableCell>
                                        {/* NVL sử dụng */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full text-left text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextArea
                                              value={item.componentUsed}
                                              size="small"
                                              className="!w-[400px] !rounded-none"
                                              onChange={(value) => {
                                                handleChangeString(
                                                  value,
                                                  "componentUsed",
                                                  index
                                                );
                                              }}
                                              autoSize
                                            />
                                          ) : (
                                            item.componentUsed
                                          )}
                                        </TableCell>
                                        {/* Khuôn */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-left text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <Select
                                              mode="multiple"
                                              size="small"
                                              showSearch
                                              disabled={
                                                item.soLuongGhiNhanDat +
                                                item.soLuongGhiNhanKhongDat !==
                                                0
                                              }
                                              allowClear
                                              defaultValue={item.molds.map(m => {
                                                return {
                                                  key: m,
                                                  value: m
                                                }
                                              })}
                                              // defaultValue={(() => {
                                              //   return listMold.filter((m) =>
                                              //     item.molds.includes(m.key + "")
                                              //   )
                                              // })()}
                                              className="!w-[400px]"
                                              options={listMold}
                                              onChange={(value, option) => {
                                                handleChangeAutoMulti(
                                                  value,
                                                  option,
                                                  index
                                                );
                                              }}
                                              optionLabelProp="label"
                                              // onSearch={async (value) => {
                                              //   await debounceHandler(value);
                                              // }}
                                              filterOption
                                              onFocus={async () => {
                                                await debounceHandler("");
                                              }}
                                              tagRender={(prop) => (
                                                <Tag
                                                  style={{ marginRight: 3 }}
                                                  closable={prop.closable}
                                                  onClose={prop.onClose}
                                                >
                                                  {prop.value
                                                    .split("|")
                                                    .shift()
                                                    .trim()}
                                                </Tag>
                                              )}
                                            />
                                          ) : (
                                            item.moldCode
                                          )}
                                        </TableCell>
                                        {/* Thời gian định mức */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField
                                              defaultValue={
                                                item.ratedTime &&
                                                item.ratedTime.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 5,
                                                    maximumFractionDigits: 5,
                                                  }
                                                )
                                              }
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "ratedTime",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className="text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                            />
                                          ) : (
                                            item.ratedTime &&
                                            item.ratedTime.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 5,
                                                maximumFractionDigits: 5,
                                              }
                                            )
                                          )}
                                        </TableCell>
                                        {/* Thời gian canh máy/chuyền */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField

                                              defaultValue={
                                                item.tgCanhMay &&
                                                item.tgCanhMay.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 5,
                                                    maximumFractionDigits: 5,
                                                  }
                                                )
                                              }
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "tgCanhMay",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className="text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                            />
                                          ) : (

                                            item.tgCanhMay &&
                                            item.tgCanhMay.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 5,
                                                maximumFractionDigits: 5,
                                              }
                                            )
                                          )}
                                        </TableCell>
                                        {/* % Ước tính hoàn thành */}
                                        {/* <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {formatNumber(item.estimateComplete * 100, 3) + '%'}
                                        </TableCell> */}
                                        {/* SL nhân công kế hoạch */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField
                                              value={item.quantityOfWorker}
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "quantityOfWorker",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className="text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                            />
                                          ) : (
                                            formatNumber(
                                              item.quantityOfWorker,
                                              0
                                            )
                                          )}
                                        </TableCell>
                                        {/* SL nhân công canh máy/chuyền */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField
                                              value={item.slNhanCongCanhMay}
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "slNhanCongCanhMay",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className="text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                            />
                                          ) : (
                                            item.slNhanCongCanhMay &&
                                            formatNumber(
                                              item.slNhanCongCanhMay,
                                              0
                                            )
                                          )}
                                        </TableCell>
                                        {/* SL máy móc kế hoạch */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField
                                              value={item.quantityEquipPerStep}
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "quantityEquipPerStep",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className="text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                            />
                                          ) : (
                                            formatNumber(
                                              item.quantityEquipPerStep,
                                              0
                                            )
                                          )}
                                        </TableCell>
                                        {/* Số SP/ Tờ/ Công đoạn */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {isEdit ? (
                                            <TextField
                                              value={item.productPerPage}
                                              onChange={(e) => {
                                                handleChangeValue(
                                                  e,
                                                  index,
                                                  "productPerPage",
                                                  e.target.value
                                                );
                                              }}
                                              type="number"
                                              className="text-truncate [&>div>input]:text-right truncated [&>div]:!px-2 [&>div]:!py-1 [&>div]:!text-[13px] [&>div>input]:!p-0 [&>div]:!rounded-none text-gray-700 border border-gray-300 px-1 py-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:border-0"
                                            />
                                          ) : (
                                            // formatNumber(item.productPerPage, 0)
                                            item.productPerPage
                                          )}
                                        </TableCell>
                                        {/* Số lượng thực hiện theo từng công đoạn */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {formatNumber(item.productPerStep, 3)}
                                        </TableCell>
                                        {/* Tổng số SP */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {formatNumber(item.totalQuantity, 3)}
                                        </TableCell>


                                        {/* chi phí gia công in offset */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {formatNumber(item.chiPhiGiaCongInOffset, 0)}
                                        </TableCell>
                                        {/* chi phí bản kẽm */}
                                        <TableCell
                                          sx={[Style.MuiTableCellRootTd]}
                                          className=" whitespace-nowrap border w-full !text-right text-gray-700   px-1 py-1 text-default focus-visible:outline-none bg-white  focus:border-blue-500 caret-blue-600 disabled:border-0"
                                        >
                                          {formatNumber(item.chiPhiBanKem, 0)}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                ) : (
                                  <TableRow>
                                    <TableCell
                                      colSpan={
                                        dataTitle.routingDetailColumns.length +
                                        1
                                      }
                                      sx={[Style.MuiTableCellRootTd]}
                                      className="px-2  whitespace-nowrap !text-center"
                                    >
                                      Không tìm thấy
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    </CardContent>
                  </Collapse>
                </Card>
              </div>
            </TabPanel>
            <TabPanel value="2">
              {workOrderStore.getWODetailsResponse.data?.infoPallet && (
                <PalletDetail
                  data={workOrderStore.getWODetailsResponse.data.infoPallet}
                />
              )}
            </TabPanel>
            <TabPanel value="3">
              {workOrderStore.getWODetailsResponse.data?.infoPallet && (
                <HistoryConfirmStage
                  editLSX={editLSX}
                  data={workOrderStore.getWODetailsResponse.data.infoPallet}
                />
              )}
            </TabPanel>
          </TabContext>
          {/* </Box> */}
        </div>
        {/* ================================================================== */}
      </div>
    );
  });
}
